import { render, staticRenderFns } from "./AppContratos.vue?vue&type=template&id=4237d755&"
import script from "./AppContratos.vue?vue&type=script&lang=js&"
export * from "./AppContratos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports